import { createSlice } from '@reduxjs/toolkit'

let newState

const avatarSlice = createSlice({
  name: 'avatarCollection',
  initialState: {
    isLoading: false,
    avatars: {},
    currentAvatar: '',
    avatarTemplates: [],
    status: 'NOT_FETCHED',
  },
  reducers: {
    getAvatar() {
      console.log('getAvatar')
    },
    setAvatar(state, action) {
      switch (action.payload.type) {
        case 'GET_AVATAR':
          newState = {
            ...state,
            isLoading: true,
            status: 'GET_AVATAR',
            error: '',
          }
          return newState
        case 'FETCHING_SUCCESS':
          newState = {
            ...state,
            isLoading: false,
            status: 'FETCHING_SUCCESS',
            avatars: action.payload.avatars,
            allAvatars: action.payload.allAvatars,
            avatarTemplates: action.payload.avatarTemplates,
            error: '',
          }
          return newState
        case 'FETCHING_ERROR':
          newState = {
            ...state,
            isLoading: false,
            status: 'FETCHING_ERROR',
            error: action.payload.error,
          }
          return newState
        case 'FETCHING_CANCELLED':
          newState = {
            ...state,
            isLoading: false,
            status: 'FETCHING_CANCELLED',
          }
          return newState
        default:
          break
      }
    },
  },
})

export const { getAvatar, setAvatar } = avatarSlice.actions

export default avatarSlice.reducer
